import { IBuilding } from "Dashboard/scenes/HighRiseSales/domain/IBuilding";
import { useOnClickOutside } from "hooks/ClickOutside";
import { max, values } from "lodash";
import { useRef } from "react";
import { IGeneralFinancials } from "Dashboard/scenes/Projects/domain/IGeneralFinancials";
import { FormatNumber } from "utils/numberUtils";
import { IAccountReceivableFinancials } from "Dashboard/scenes/Projects/domain/IAccountReceivableFinancials";
import { IAccountPayableFinancials } from "Dashboard/scenes/Projects/domain/IAccountPayableFinancials";

interface IProps {
  active: boolean;
  setActive: Function;
  building: IBuilding;
  general: IGeneralFinancials | undefined;
  receivables: IAccountReceivableFinancials | undefined;
  payables: IAccountPayableFinancials | undefined;
}

const StatisticTooltip = ({
  building,
  active,
  setActive,
  general,
  receivables,
  payables,
}: IProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const calculateOverallBalance = (general?: IGeneralFinancials, receivables?: IAccountReceivableFinancials, payables?: IAccountPayableFinancials): number => {
    return (receivables?.paidAmount || 0) - (payables?.paidOffAmount || 0) - (general?.expensesAmount || 0);
  }

  const overallBalance = calculateOverallBalance(general, receivables, payables);
  const maxValue = Math.max(max(values(general)) || 0, overallBalance);

  const calculatePercent = (value: number): number => {
    return maxValue ? Math.round((value * 100) / maxValue) : 0;
  };

  const hideTip = () => {
    setActive(false);
  };
  useOnClickOutside(ref, hideTip);

  if (!active) return null;

  return (
    <div className="statistic-container active" ref={ref}>
      <h1>Info</h1>
      <div className="statistic">
        <h2>{building.fullName}</h2>
        <div>
          <span>Naplatili</span>
          <span>
            {receivables && FormatNumber(receivables.paidAmount)} rsd
          </span>
          <span
            className="chart-line green"
            style={{
              width: `${receivables && calculatePercent(receivables.paidAmount)
                }%`,
            }}
          ></span>
        </div>
        <div>
          <span>
            Isplatili<span className="details">(Saradnicima)</span>
          </span>
          <span>
            {payables && FormatNumber(payables.paidOffAmount)} rsd
          </span>
          <span
            className="chart-line blue"
            style={{
              width: `${payables && calculatePercent(payables.paidOffAmount)
                }%`,
            }}
          ></span>
        </div>
        < div >
          <span>
            Troškovi<span className="details">(Lager, gorivo, karneti)</span>
          </span>
          <span>
            {general && FormatNumber(general.expensesAmount)} rsd
          </span>
          <span
            className="chart-line purple"
            style={{
              width: `${general && calculatePercent(general.expensesAmount)
                }%`,
            }}
          ></span>
        </div>
        <div>
          <span>
            Troškovi<span className="details">(Lično)</span>
          </span>
          <span>
            {general && FormatNumber(general.personalExpensesAmount)} rsd
          </span>
          <span
            className="chart-line orange"
            style={{
              width: `${general &&
                calculatePercent(general.personalExpensesAmount)
                }%`,
            }}
          ></span>
        </div>
        <div>
          <span>Incidenti</span>
          <span>
            {general && FormatNumber(general.incidentsAmount)} rsd
          </span>
          <span
            className="chart-line pink"
            style={{
              width: `${general && calculatePercent(general.incidentsAmount)
                }%`,
            }}
          ></span>
        </div>

        <div>
          <span>Ukupan saldo</span>
          <span className="last-child">
            {general && FormatNumber(overallBalance)} rsd
          </span>
          <span
            className="chart-line red"
            style={{
              width: `${general && calculatePercent(overallBalance)
                }%`,
            }}
          ></span>
        </div>
        <textarea
          placeholder="Napomena"
        // defaultValue={building?.note}
        // onChange={onChange}
        ></textarea>
      </div>
    </div >
  );
};

export default StatisticTooltip;
